import React, { useRef } from 'react';
import PiscesHeroSection from '../../../components/landingPage/PiscesPage/PiscesHeroSection';
import PiscesProblemSection from '../../../components/landingPage/PiscesPage/PiscesProblemSection';
import PiscesStatsBand from '../../../components/landingPage/PiscesPage/PiscesStatsBand';
import PiscesAudienceTabs from '../../../components/landingPage/PiscesPage/PiscesAudienceTabs';
import PiscesHowItWorks from '../../../components/landingPage/PiscesPage/PiscesHowItWorks';
import PiscesDisclosureModule from '../../../components/landingPage/PiscesPage/PiscesDisclosureModule';
import PiscesQuotesSection from '../../../components/landingPage/PiscesPage/PiscesQuotesSection';
import PiscesCtaSection from '../../../components/landingPage/PiscesPage/PiscesCtaSection';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const LandingHomePisces = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <PiscesHeroSection />
            <PiscesProblemSection />
            <PiscesStatsBand />
            <PiscesAudienceTabs />
            <PiscesHowItWorks />
            <PiscesDisclosureModule />
            <PiscesQuotesSection />
            <PiscesCtaSection />
            <AeoResourcesSection icpSlug="pisces" />
        </div>
    );
};

export default LandingHomePisces;
